import cn from 'classnames';
import * as PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import * as ReactModal from 'react-modal';
import './styles.scss';
import { clearAllBodyScrollLocks, disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import * as ReactDOM from 'react-dom';

export default class Modal extends PureComponent {
  static propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func,
    showModal: PropTypes.bool,
    contentLabel: PropTypes.string,
    id: PropTypes.string,
    type: PropTypes.oneOf(['small', 'medium', 'large']),
    color: PropTypes.oneOf(['white', 'blue']),
    hasCloseIcon: PropTypes.bool,
    needChildWrap: PropTypes.bool,
    popupWrapperStyle: PropTypes.object,
    horizontalCentering: PropTypes.bool,
    zIndex: PropTypes.number,
    shouldCloseOnEsc: PropTypes.bool,
    className: PropTypes.string,
    preventCloseOnEsc: PropTypes.bool,
  };

  modal = React.createRef();
  targetElement = null;

  static defaultProps = {
    contentLabel: '',
    id: 'info',
    type: 'small',
    color: 'white',
    showModal: false,
    hasCloseIcon: true,
    needChildWrap: true,
    horizontalCentering: false,
    zIndex: 5000,
    shouldCloseOnEsc: true,
    className: '',
  };

  componentDidMount() {
    ReactModal.setAppElement('body');
  }

  componentDidUpdate(prevProps) {
    if (this.props.showModal !== prevProps.showModal && !this.props.showModal) {
      this.enableBodyScroll();
    }
  }

  componentWillUnmount() {
    clearAllBodyScrollLocks();
  }

  // для ios, safari не жалует fixed position потому достаем контейнер с position:absolute
  onAfterOpen = () => {
    try {
      this.targetElement = ReactDOM.findDOMNode(this.contentRef);
      disableBodyScroll(this.targetElement);
    } catch (e) {
      return null;
    }
  };

  onRequestClose = (event) => {
    const { preventCloseOnEsc } = this.props;
    if (preventCloseOnEsc && event.keyCode === 27) {
      return;
    }
    this.onAfterClose();
  };

  onAfterClose = () => {
    this.enableBodyScroll();
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  enableBodyScroll = () => {
    enableBodyScroll(this.targetElement);
  };

  render() {
    const {
      showModal,
      children,
      contentLabel,
      id,
      type,
      color,
      hasCloseIcon,
      needChildWrap,
      horizontalCentering,
      popupWrapperStyle,
      zIndex,
      shouldCloseOnEsc,
      className,
    } = this.props;
    const popupClassNames = cn('popup', `popup__${type}`, className);
    const popupWrapperClassNames = cn('popup_wrapper', `popup_wrapper__${color}`, 'info');
    const styles = horizontalCentering
      ? {
          overlay: {
            zIndex: zIndex,
            backgroundColor: 'rgba(74,74,74,0.3)',
          },
          content: {
            border: 'none',
            backgroundColor: 'rgba(0,0,0,0)',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          },
        }
      : {
          overlay: {
            zIndex: zIndex,
            backgroundColor: 'rgba(74,74,74,0.3)',
          },
          content: {
            border: 'none',
            backgroundColor: 'rgba(0,0,0,0)',
            left: 0,
            top: 0,
            right: 0,
            bottom: 0,
          },
        };

    return (
      <ReactModal
        ref={this.modal}
        isOpen={showModal}
        contentlabel={contentLabel}
        onAfterOpen={this.onAfterOpen}
        onRequestClose={this.onRequestClose}
        shouldCloseOnEsc={shouldCloseOnEsc}
        contentRef={(node) => (this.contentRef = node)}
        style={styles}
      >
        {needChildWrap ? (
          <div
            className={cn([
              'mfp-container mfp-inline-holder',
              { 'mfp-container-horizontalCentering': horizontalCentering },
            ])}
          >
            <div className="mfp-content">
              <div className={popupClassNames} id={id}>
                {hasCloseIcon ? (
                  <a className="mfp-close popup_close" onClick={this.onAfterClose}>
                    <span className="replace_text">Закрыть</span>
                  </a>
                ) : null}
                <div className={popupWrapperClassNames} style={popupWrapperStyle}>
                  {children}
                </div>
              </div>
            </div>
          </div>
        ) : (
          children
        )}
      </ReactModal>
    );
  }
}
